// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useSearchAndFilter, useElseware } from 'utilities/hooks';

// Components
import BaseCard from './_common/baseCard.js';

// Icons
import { FiTrendingUp } from 'react-icons/fi';

const InitiativesSummaryFullComponent = ({ promptKey, forceOpen }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { label } = useLabels();
    const { filtered } = useSearchAndFilter({
        instanceName: 'initiatives',
    });
    const { ewCreate } = useElseware();

    // Make a short summary including total amount of funded in DKK or EUR, which target groups are reached and the number reached, the results achieved and key learnings.
    // At the end of the summary, indicate the reports included, specifying the initiative name, report type, date, and status.

    // ///////////////////
    // REFS
    // ///////////////////

    // ///////////////////
    // DATA
    // ///////////////////

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            <BaseCard
                {...{
                    forceOpen,
                    title: label('AI_PromptTitle_Initiatives_Summary_Full'),
                    description: label(
                        'AI_PromptDescription_Initiatives_Summary_Full'
                    ),
                    relation: {
                        key: '',
                        id: '',
                        name: '',
                        type: '',
                    },
                    icon: FiTrendingUp,
                    promptKey,
                    systemPrompts: [
                        'You will help the user to summarize the initiatives based on the prompts provided.',
                        'Do not include any general heading or other headings than the sections asked for.',
                        'Do not mention object keys like "Status__c" or anything with __c in them. You may refer but not include them.',
                        'Do not ask followup questions.',
                        'The answer you provide should be in unescaped html tags for immediate parsing.',
                        'No wrapping <div>. Use <p> tags for paragraphs and <strong> for bold text and headings.',
                    ],
                    promptDataGetter: async () => {
                        // Get initiatives based on filtered ids
                        const { data: allInitiatives } = await ewCreate(
                            'initiative/get',
                            {
                                ids: filtered.map(x => x.Id),
                            }
                        );

                        return JSON.stringify(allInitiatives);
                    },
                }}
            />
        </>
    );
};

InitiativesSummaryFullComponent.propTypes = {
    promptKey: t.string.isRequired,
};

InitiativesSummaryFullComponent.defaultProps = {
    promptKey: '',
};

export default InitiativesSummaryFullComponent;
